import { useNavigate } from 'react-router-dom';
import { Shell } from '../layout/Shell.js';
import { useSession } from '../state/session.js';
import { logout } from '../api/auth.js';
import { setStatus } from '../api/driver.js';

export function AccountPage() {
  const navigate = useNavigate();
  const user = useSession((s) => s.user);
  const online = useSession((s) => s.online);
  const refreshToken = useSession((s) => s.refreshToken);
  const setOnline = useSession((s) => s.setOnline);
  const clear = useSession((s) => s.clear);

  const onSignOut = async () => {
    if (online) {
      try {
        await setStatus('offline');
      } catch {
        /* server may already have closed the session */
      }
      setOnline(false);
    }
    if (refreshToken) {
      try {
        await logout(refreshToken);
      } catch {
        /* token already invalid; clear locally regardless */
      }
    }
    clear();
    navigate('/login', { replace: true });
  };

  return (
    <Shell>
      <div className="px-4 pt-[max(env(safe-area-inset-top),16px)]">
        <h1 className="font-display text-2xl font-bold">Account</h1>

        {user ? (
          <section className="card mt-4 p-4">
            <p className="font-display text-lg font-semibold">{user.name}</p>
            <p className="text-sm text-muted">{user.email}</p>
            <p className="num text-sm text-muted">{user.phone}</p>
            <p className="chip mt-3">{online ? 'Online' : 'Offline'}</p>
          </section>
        ) : null}

        <section className="mt-6 space-y-2">
          <h2 className="text-xs font-semibold uppercase tracking-wide text-muted">Help</h2>
          <div className="card divide-y divide-line">
            <p className="px-4 py-3 text-sm">Vehicle and document updates: visit a Raahi partner centre.</p>
            <p className="px-4 py-3 text-sm">Driver support: <span className="text-text">drivers@raahi.test</span></p>
          </div>
        </section>

        <button type="button" onClick={onSignOut} className="btn-ghost mt-6 w-full text-red-soft">
          Sign out
        </button>
      </div>
    </Shell>
  );
}
